import fetch from 'cross-fetch';
import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, defaultDataIdFromObject as dataIdFromObject, } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { ErrorsEnum } from '@libs/backend-common';
import { getCfSessionToken } from './cfSessionHelpers';
export const getApolloClient = (uri, tokenKey, shouldSendCookies = false) => {
    const cache = new InMemoryCache({
        dataIdFromObject,
    });
    const httpLink = new HttpLink({
        uri,
        fetch,
        credentials: shouldSendCookies ? 'include' : undefined,
    });
    let onUnauthorized = () => ({});
    let onInvalidDevToken = () => ({});
    const requestInterceptor = async (_, { headers }) => {
        const token = localStorage.getItem(tokenKey);
        // cloudflare addition
        const cfSessionToken = getCfSessionToken();
        const additionalHeaders = {
            'CF-Access-JWT-Assertion': cfSessionToken,
            'Cf-ApSession': cfSessionToken,
        };
        return {
            headers: {
                ...headers,
                ...(cfSessionToken ? additionalHeaders : {}),
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
        };
    };
    const responseInterceptor = (operation, forward) => {
        return forward(operation).map((response) => {
            const context = operation.getContext();
            const { response: { headers }, } = context;
            if (headers) {
                const updatedToken = headers.get('refreshed-access-token');
                if (updatedToken) {
                    localStorage.setItem(tokenKey, updatedToken);
                }
            }
            return response;
        });
    };
    const errorInterceptor = ({ graphQLErrors }) => {
        if (graphQLErrors) {
            for (const err of graphQLErrors) {
                if (err?.message === ErrorsEnum.INVALID_DEVICE_TOKEN) {
                    onInvalidDevToken();
                }
                else if (err.extensions.code === 'UNAUTHENTICATED') {
                    onUnauthorized();
                    break;
                }
            }
            // if (response?.errors) {
            //   const foundUnathorizationCode = response.errors.find((err) => {
            //     const response = err.extensions?.response as ErrorResponse;
            //     if (
            //       Object.prototype.hasOwnProperty.call(response || {}, 'statusCode')
            //     ) {
            //       return response.statusCode === 401;
            //     }
            //     return false;
            //   });
            //   if (foundUnathorizationCode) {
            //     onUnauthorized();
            //   }
            // }
        }
    };
    const authLink = setContext(requestInterceptor);
    const afterwareLink = new ApolloLink(responseInterceptor);
    const errorLink = onError(errorInterceptor);
    const link = ApolloLink.from([afterwareLink, errorLink, authLink, httpLink]);
    const client = new ApolloClient({
        cache,
        link,
    });
    return {
        client,
        setOnUnauthorized: (callback) => {
            onUnauthorized = callback;
        },
        setOnInvalidDevToken: (callback) => {
            onInvalidDevToken = callback;
        },
    };
};
//# sourceMappingURL=apollo.js.map